import { render } from "./LiveAudioTrack.vue?vue&type=template&id=a1b47bc2&scoped=true"
import script from "./LiveAudioTrack.vue?vue&type=script&lang=js"
export * from "./LiveAudioTrack.vue?vue&type=script&lang=js"

import "./LiveAudioTrack.vue?vue&type=style&index=0&id=a1b47bc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b47bc2"]])

export default __exports__